<label class="switch">
  <input type="checkbox" [(ngModel)]="isOnline" (click)="change()">
  <span class="slider round"></span>
</label>
